import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import TextareaAutosize from "src/shared/v-components/ui/form/TextareaAutosize.vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StringComponentVariableBuiltValue',
    props: {
        value: {}
    },
    emits: ["focus"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isString = (value) => {
            return typeof value === "string";
        };
        const valueProxy = computed(() => {
            return isString(props.value) ? props.value : "";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(TextareaAutosize, {
                "model-value": valueProxy.value,
                readonly: true,
                onClick: _cache[0] || (_cache[0] = ($event) => (emit('focus')))
            }, null, 8 /* PROPS */, ["model-value"]));
        };
    }
});
